export class OnkyoRz {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1091300010700010';
        this.power = false;
        this.videoMatrixRoutes = '0';
        this.volume = 60;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'amxBeacon',
                regExp: /AMX/i,
                callback: (match) => {
                    this.socket.send(`AMXB<-SDKClass=Receiver><-Make=ONKYO><-Model=TX-RZ630><-Revision=1.0.0>`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /!1FWVQSTN/i,
                callback: (match) => {
                    this.socket.send(`!1FWV${this.firmwareVersion}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /!1PWRQSTN/i,
                callback: (match) => {
                    this.socket.send(`!1PWR0${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /!1PWR0(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`!1PWR0${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'videoMatrixRoutesQuery',
                regExp: /!1SLIQSTN/i,
                callback: (match) => {
                    this.socket.send(`!1SLI${this.videoMatrixRoutes}`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /!1SLI(.+)/i,
                callback: (match) => {
                    this.videoMatrixRoutes = match[1];
                    this.socket.send(`!1SLI${this.videoMatrixRoutes}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /!1AMTQSTN/i,
                callback: (match) => {
                    this.socket.send(`!1AMT0${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /!1AMT0(.+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1';
                    this.socket.send(`!1AMT0${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /!1MVLQSTN/i,
                callback: (match) => {
                    this.socket.send(`!1MVL${this.volume.toString(16).padStart(2, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /!1MVL(.+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 16);
                    this.socket.send(`!1MVL${this.volume.toString(16).padStart(2, '0')}`);
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['\r'],
        };
        this.sendTerminator = '\x1A\r\n';
    }
    onConfigure(config) {
        // Initialize the video source selection to a valid value from the config.
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoMatrixRoutes === code)
                return;
            if (lowestCode === undefined || parseInt(code, 16) < parseInt(lowestCode, 16)) {
                lowestCode = code;
            }
        }
        this.videoMatrixRoutes = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '10';
        // Send the AMX beacon.
        this.socket.send(`AMXB<-SDKClass=Receiver><-Make=ONKYO><-Model=TX-RZ630><-Revision=1.0.0>`);
    }
}
OnkyoRz.emulatorType = 'socketEmulator';
OnkyoRz.key = '-LvG5s2whBBxCDDA1EC6';
